import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopicRoutingModule } from './topic-routing.module';
import { ExercisesComponent } from './exercises/exercises.component';
import { FormsModule } from '@angular/forms';
import { TopicService } from './topic.service';
import { LanguageProvider } from './language.provider';
import { NumberCardsComponent } from './number-cards/number-cards.component';
import { TopicComponent } from './topic/topic.component';
import { TnumberCardsComponent } from './number-cards/tnumber-cards.component';
import { TExercisesComponent } from './t-exercises/t-exercises.component';
import { NumberCardsService } from './number-cards.service';
import { DndModule } from 'ng2-dnd';
import { TAllExercisesComponent } from './t-all-exercises/t-all-exercises.component';
import { NumberCardsReduceBucketComponent } from './number-cards-reduce-bucket/number-cards-reduce-bucket.component';
import { TNumberCardsReduceBucketComponent } from './t-number-cards-reduce-bucket/t-number-cards-reduce-bucket.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PositionCardComponent } from './position-card/position-card.component';
import { TPositionCardComponent } from './t-position-card/t-position-card.component';
import { SuperExerciseComponent } from './super-exercise/super-exercise.component';
import { ExamComponent } from './exam/exam.component';
import { EvaluationComponent } from './evaluation/evaluation.component';
import { SharedModule } from '../shared/shared.module';
import { AddCardRepresentationComponent } from './add-card-representation/add-card-representation.component';
import { TAddCardRepresentationComponent } from './t-add-card-representation/t-add-card-representation.component';
import { OpenQuestionComponent } from './open-question/open-question.component';
import { TOpenQuestionComponent } from './t-open-question/t-open-question.component';
import { DiscoverComponent } from './discover/discover.component';
import { TExamComponent } from './t-exam/t-exam.component';
import { TAllExamsComponent } from './t-all-exams/t-all-exams.component';
import { MultipleChoiceComponent } from './multiple-choice/multiple-choice.component';
import { TMultipleChoiceComponent } from './t-multiple-choice/t-multiple-choice.component';
import { ValidCardsDirective } from './valid-cards.directive';
import { PlaygroundComponent } from './playground/playground.component';
import { TSuperExerciseComponent } from './t-super-exercise/t-super-exercise.component';
import { TDiscoverComponent } from './t-discover/t-discover.component';

@NgModule({
  imports: [
    CommonModule,
    TopicRoutingModule,
    FormsModule,
    DndModule,
    NgbModule,
    SharedModule
  ],
  providers: [TopicService,
    LanguageProvider,
    NumberCardsService,
    { provide: APP_INITIALIZER, useFactory: languageProviderFactory, deps: [LanguageProvider], multi: true }],
  declarations: [
    ExercisesComponent,
    NumberCardsComponent,
    TopicComponent,
    TnumberCardsComponent, 
    TExercisesComponent, 
    TAllExercisesComponent, 
    NumberCardsReduceBucketComponent, 
    TNumberCardsReduceBucketComponent, 
    PositionCardComponent, 
    TPositionCardComponent, 
    ExamComponent, 
    EvaluationComponent, 
    AddCardRepresentationComponent,
    TAddCardRepresentationComponent, 
    OpenQuestionComponent, 
    TOpenQuestionComponent, 
    DiscoverComponent, 
    TExamComponent, 
    TAllExamsComponent, 
    MultipleChoiceComponent, 
    TMultipleChoiceComponent, 
    ValidCardsDirective, 
    PlaygroundComponent, TDiscoverComponent]
})
export class DataRepresentationModule { }

export function languageProviderFactory(provider: LanguageProvider) {
  return () => provider.load();
}

